import React from 'react'
import {PropTypes} from 'prop-types'

import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';

// A "generic" button componente used to personalize with any material icon.
export const ButtonGeneric = ({to = "", icon, iconClass = "", iconSize = "md-18", onClick = null , linkClass = "", buttonClass = "", ...props}, context) => {
    
    const buttonClassName = (buttonClass)?"snx-btn-action " +  buttonClass:"snx-btn-action";
    const iconClassName = (iconClass)?`material-icons ${iconClass} ${iconSize}`:`material-icons snx-icon-link ${iconSize}`;
    const genericIcon = (icon)?icon:"slideshow";

    return (    
        <Link to={to} className={linkClass}>
            <Button onClick={onClick} className={buttonClassName} {...props}>
                <i className={iconClassName} >{genericIcon}</i>
            </Button>
        </Link>
    )
}

ButtonGeneric.contextTypes = {
    t: PropTypes.func
}

